import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { TruckShiftEntity } from 'src/entities/TruckShift.entity';

export const truckShiftsQueryKey = (selectedCompanyId: number, startOn: string, endOn: string) =>
  ['useQueryTruckShifts', selectedCompanyId, startOn, endOn] as const;

export const truckShiftsRequestPath = (startOn: string, endOn: string): string =>
  `/api/v5/truck_shifts?start_on=${startOn}&end_on=${endOn}`;

const getAll = (startOn: string, endOn: string) => async (): Promise<TruckShiftEntity[]> => {
  const response = await axios.get<TruckShiftEntity[]>(truckShiftsRequestPath(startOn, endOn));
  return response.data;
};

export const useQueryTruckShifts = (
  selectedCompanyId: number,
  startOn: string,
  endOn: string,
  enabled: boolean,
) => useQuery(
  truckShiftsQueryKey(selectedCompanyId, startOn, endOn),
  getAll(startOn, endOn),
  { enabled, staleTime: Infinity },
);
